
import { SEO } from "@/components/seo/SEO";
const PrivacyPolicy = () => {
  return (
    <>
      <SEO 
        title="Privacy Policy | Careerfy"
        description="Learn how Careerfy handles your data across interview practice, resume analysis, and career guidance."
        path="/privacy-policy"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "Privacy Policy",
          url: "/privacy-policy"
        }}
      />
      <div className="max-w-4xl mx-auto px-4 py-16">
      <h1 className="text-title font-semantic-bold text-primary mb-8">Privacy Policy</h1>
      
      <div className="space-y-6 text-gray-600">
        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">1. Information Collection</h2>
          <p>HeyLiving Club LLP ("Careerfy") collects information that you provide directly to us, including:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>Personal information (name, email, phone number)</li>
            <li>Resume and professional information</li>
            <li>Interview recordings and responses</li>
            <li>Account credentials</li>
          </ul>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">2. Use of Information</h2>
          <p>We use the collected information to:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>Provide and improve our interview preparation services</li>
            <li>Analyze and enhance user experience</li>
            <li>Generate personalized feedback and recommendations</li>
            <li>Communicate with users about our services</li>
          </ul>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">3. Data Security</h2>
          <p>We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.</p>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">4. Data Sharing</h2>
          <p>We do not sell or rent your personal information to third parties. We may share data with service providers who assist in operating our platform.</p>
        </section>

        <section>
          <h2 className="text-header font-semantic-semibold text-primary mb-4">5. Contact Information</h2>
          <p>For privacy-related inquiries, please contact us:</p>
          <ul className="list-none space-y-2 mt-2">
            <li>Company: HeyLiving Club LLP</li>
            <li>Email: Info@careerfy.ai</li>
            <li>Phone: +91 9552526258</li>
          </ul>
        </section>
      </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
